export class ChatMessage {
  id: string;
  recipient: string;
  sender: string;
  text: string;
  date: Date;
  patientEmail: string;
  patientName: string;
  patientSurname: string;
  doctorName: string;
  doctorSurname: string;
  nameSender: string;
  surnameSender: string;
  read: boolean;
  fileIsPresent: any;


  // tslint:disable-next-line:max-line-length
  constructor(recipient: string, sender: string, text: string) {
    this.recipient = recipient;
    this.sender = sender;
    this.text = text;
  }
}
